export default __webpack_public_path__ + "static/media/100_desktop.6ce06e5a.jpg";